export const paymentModeEn = {
  "Donner le Nom": "Give the name",
  "Code": "Code",
  "Donner le Code": "Give the Code",

  // server Side  

  "La methode deja existe.": "The payment method already exists.",
  "le nom est obligatoire.": "the name is required.",
  "le code est obligatoire.": "the code is required.",


}